'use client';
import Section from '@repo/ui/src/components/Section';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { HeaderVariationProps } from '@repo/ui/src/types';

interface Props {
  heading: string;
  headerVariation: HeaderVariationProps;
  headingStyle: any;
  lilHeading: string;
  description: string;
  buttons: Array<any>;
}

export const SplitToutContent = ({
  heading,
  headerVariation,
  headingStyle,
  lilHeading,
  description,
  buttons,
}: Props) => (
  <Section white gutterX gutterY basePadding className="pb-0">
    <div className="grid grid-cols-12 gap-x-4">
      <div className="col-span-12 md:col-span-5">
        <ToutContent
          heading={heading}
          headerVariation={headerVariation}
          headingStyleVariant={headingStyle || 'h2'}
          lilHeading={lilHeading}
          forceDivider
          align="left"
        />
      </div>
      <div className="hidden md:block md:col-span-1" />
      <div className="col-span-12 md:col-span-6">
        <ToutContent description={description} buttons={buttons} align="left" />
      </div>
    </div>
  </Section>
);

export default SplitToutContent;
